// src/components/molecules/ViewModeSelector/ViewModeSelector.jsx
import React from 'react';
import PropTypes from 'prop-types';
import ViewToggle from '../../atoms/ViewToggle/ViewToggle';

/**
 * ViewModeSelector - Componente molecular para seleção do modo de visualização
 * 
 * Este componente encapsula o ViewToggle com funcionalidades adicionais.
 * Segue o princípio do Atomic Design como uma "molécula".
 */
const ViewModeSelector = ({
  value,
  onChange,
  className = '',
  ...props
}) => {
  const handleChange = (event, newValue) => {
    if (newValue) {
      onChange(newValue);
      
      // Salvar a preferência no localStorage
      localStorage.setItem('atomic_variant', newValue);
    }
  };
  
  return (
    <ViewToggle
      value={value}
      onChange={handleChange}
      className={`view-mode-selector ${className}`}
      {...props}
    />
  );
};

ViewModeSelector.propTypes = {
  value: PropTypes.oneOf(['detailed', 'list', 'measurement']).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default ViewModeSelector;
